<template>
  <b-field :label="$t(label)">
    <b-select
      @input="rangeUpdated"
      :placeholder="$t('Desde')"
      v-model="selectedLeftSideOption"
    >
      <option
        v-for="option in leftSideOptions"
        :value="option.value"
        :key="option.value"
        >{{ $t(option.text) | formatMoney }}</option
      >
    </b-select>
    <b-select
      @input="rangeUpdated"
      :placeholder="$t('Hasta')"
      v-model="selectedRightSideOption"
    >
      <option
        v-for="option in filterRightSideOptions(rightSideOptions)"
        :value="option.value"
        :key="option.value"
        >{{ $t(option.text) | formatMoney }}</option
      >
    </b-select>
  </b-field>
</template>

<script>
export default {
  components: {},
  props: {
    options: Array,
    value: Array,
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      leftSideOptions: [],
      selectedLeftSideOption: null,
      rightSideOptions: [],
      selectedRightSideOption: null,
      rangeListOptions: [],
      selected: []
    }
  },
  watch: {
    value: function(val) {
      let self = this
      self.selected = val

      if (self.selected.length > 0) {
        self.selectedLeftSideOption = self.options.filter(function(elem) {
          return elem.id == self.selected[0]
        })[0].id
        self.selectedRightSideOption = self.options.filter(function(elem) {
          return elem.id == self.selected[self.selected.length - 1]
        })[0].id
      }
    }
  },
  computed: {},
  filters: {
    formatMoney: function(value) {
      return isNaN(value)
        ? value
        : value == ''
        ? '0 €'
        : parseInt(value).toLocaleString('ES') + '€'
    }
  },
  created() {},
  mounted() {
    let self = this
    self.options.forEach(function(elem) {
      let rangeParts = elem.title.split('-').map(function(element) {
        let elementVal = parseInt(element)
        return isNaN(elementVal) ? element : elementVal
      })
      self.leftSideOptions.push({ text: rangeParts[0], value: elem.id })
      self.rightSideOptions.push({ text: rangeParts[1], value: elem.id })
      self.rangeListOptions.push(elem.id)
    })
    self.leftSideOptions = [...new Set(self.leftSideOptions)]
    self.rightSideOptions = [...new Set(self.rightSideOptions)]
  },
  methods: {
    rangeUpdated: function() {
      let self = this
      let leftIndex = this.rangeListOptions.indexOf(this.selectedLeftSideOption)
      let rightIndex = this.rangeListOptions.indexOf(
        this.selectedRightSideOption
      )
      let selectedOptions =
        leftIndex != rightIndex
          ? this.rangeListOptions.slice(leftIndex, rightIndex + 1)
          : [this.rangeListOptions[leftIndex]]
      self.selected = selectedOptions
      this.$emit('input', self.selected)
    },
    filterRightSideOptions: function(options) {
      let self = this
      let toRetOptions = options.filter(function(elem) {
        return (
          self.rangeListOptions.indexOf(elem.value) >=
          self.rangeListOptions.indexOf(self.selectedLeftSideOption)
        )
      })
      if (toRetOptions[0]) {
        if (!toRetOptions[0].text) {
          return [toRetOptions[0]]
        }
      }

      return toRetOptions
    }
  }
}
</script>
<<style lang="scss">
.option {
  text-align: right;
}
</style>
